module.exports = __webpack_public_path__ + "img/huoyueIcon.844d20f1.png";